import {ReactElement, SelectHTMLAttributes} from "react";
import classNames from "classnames";
import {FiChevronDown} from "react-icons/fi";
import "./FormControls.scss";

/**
 * Select — themed replacement for the legacy select. Spreads native
 * SelectHTMLAttributes onto a styled `<select>` with a chevron, per the anchor
 * `.select` spec (mono, uppercase, dark surface).
 */
function Select(props: SelectHTMLAttributes<HTMLSelectElement>): ReactElement {
    const {className, children, ...rest} = props;
    return (
        <div className={classNames("dp-select", {"is-disabled": props.disabled})}>
            <select className={classNames("dp-select__field", className)} {...rest}>
                {children}
            </select>
            <FiChevronDown className="dp-select__chevron"/>
        </div>
    );
}

export default Select;
